/*
 *
 * PciEmailDocumentsModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import UploadedItem from '@nexidigital/uploadeditem'
import { DocumentPDF } from '@nexidigital/iconlibrary'
import formattedMessage from './languageModule'
import { utmConverter } from 'Utility/globalMethods'

const PciEmailDocumentsModal = ({ email, primaryAction, idSurvey, partitaIva, actions }) => {
  const getCurrentMonthYear = () => {
    const now = new Date()
    return now.toLocaleDateString('en-US', { month: '2-digit', year: 'numeric' }).replace('/', '/')
  }

  const handleSendEmail = async () => {
    const convertedPartitaIva = await utmConverter(partitaIva)
    primaryAction({ idSurvey, partita_iva: convertedPartitaIva })
    actions.doHidePopup()
  }

  return (
    <MerchantModal
      open
      primaryButtonLabel={formattedMessage.sendEmailButtonLabel}
      primaryAction={handleSendEmail}
      onClose={() => actions.doHidePopup()}
      title={formattedMessage.modalTitle}
      description={formattedMessage.modalDescription(email)}
    >
      <MerchantGenericCard title={formattedMessage.documentsCardTitle}>
        <div className='documentPCIPopup'>
          <UploadedItem
            icon={<DocumentPDF size='24' type='fill' />}
            fileName={formattedMessage.fileName1}
            labelFormat={getCurrentMonthYear()}
            labelSize={formattedMessage.fileFormat}
            onClickIconButton={undefined}
          />
          <UploadedItem
            icon={<DocumentPDF size='24' type='fill' />}
            fileName={formattedMessage.fileName2}
            labelFormat={getCurrentMonthYear()}
            labelSize={formattedMessage.fileFormat}
            onClickIconButton={undefined}
          />
        </div>
      </MerchantGenericCard>
    </MerchantModal>
  )
}

PciEmailDocumentsModal.propTypes = {
  actions: PropTypes.object.isRequired,
  idSurvey: PropTypes.string.isRequired,
  partitaIva: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  primaryAction: PropTypes.func.isRequired
}

PciEmailDocumentsModal.defaultProps = {
  actions: {},
  idSurvey: '',
  partitaIva: '',
  email: '',
  primaryAction: () => { }
}

export default (PciEmailDocumentsModal)
